export default __webpack_public_path__ + "static/media/quarry.54b6c7b4.svg";